import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { retry, timeout, catchError } from "rxjs/operators";
import { Observable, throwError } from "rxjs";
import { ErrorHandlingService } from './error-handling.service';
import { retryWithBackoff, timeoutWithFallback } from './retry-operators.service';
@Injectable({
  providedIn: 'root'
})
export class HttpMethodService {
 
  constructor(
    private httpService: HttpClient,
    private errorHandling: ErrorHandlingService
  ) {}

  /**
   *
   * This function will call GET APIs.
   */
  getMethod(endpoint: any, apiConstant: any) {
    return this.httpService.get<any>(endpoint + apiConstant).pipe(
      timeoutWithFallback(60000, 'Request timed out. Please try again.'),
      retryWithBackoff({ maxRetries: 3, baseDelay: 1000 }),
      catchError((error: HttpErrorResponse) => this.errorHandling.handleError(error, { 
        showToast: true,
        logToConsole: true 
      }))
    );
  }//end of getMethod


  getMethod2(endpoint: any) {
    return this.httpService.get<any>(endpoint).pipe(
      timeoutWithFallback(60000, 'Request timed out. Please try again.'),
      retryWithBackoff({ maxRetries: 3, baseDelay: 1000 }),
      catchError((error: HttpErrorResponse) => this.errorHandling.handleError(error, { 
        showToast: true,
        logToConsole: true 
      }))
    );
  }

  

  loginOuthMethod(endpoint: any, apiConstant: any, headers: HttpHeaders, httpService?: any) {
    return this.httpService.get<any>(endpoint + apiConstant, { headers }).pipe(
      timeoutWithFallback(60000, 'Login request timed out. Please try again.'),
      catchError((error: HttpErrorResponse) => this.errorHandling.handleError(error, { 
        showToast: true,
        logToConsole: true,
        customMessage: 'Login failed. Please check your credentials and try again.'
      }))
    );
  }

  /**
   *
   * This function will call POST APIs.
   */
  postMethod(endpoint: any, apiConstant: any, payload: any,  headers: HttpHeaders, httpService?: any) {
    return this.httpService.post<any>(endpoint + apiConstant, payload,  { headers }).pipe(
      timeoutWithFallback(60000, 'Request timed out. Please try again.'),
      retryWithBackoff({ maxRetries: 3, baseDelay: 1000 }),
      catchError((error: HttpErrorResponse) => this.errorHandling.handleError(error, { 
        showToast: true,
        logToConsole: true 
      }))
    );
  }//end of postMethod

  putMethod(endpoint: any, apiConstant: any, payload: any,  headers: HttpHeaders, httpService?: any) {
    return this.httpService.put<any>(endpoint + apiConstant, payload,  { headers }).pipe(
      timeoutWithFallback(60000, 'Request timed out. Please try again.'),
      retryWithBackoff({ maxRetries: 3, baseDelay: 1000 }),
      catchError((error: HttpErrorResponse) => this.errorHandling.handleError(error, { 
        showToast: true,
        logToConsole: true 
      }))
    );
  }//end of putMethod

    /**
   *
   * This function will call POST APIs.
   */
     loginpostMethod(endpoint: any, apiConstant: any, payload: any, headers: HttpHeaders, httpService?: any) {
       return this.httpService.post<any>(endpoint + apiConstant, payload,  { headers }).pipe(
         timeoutWithFallback(60000, 'Login request timed out. Please try again.'),
         catchError((error: HttpErrorResponse) => this.errorHandling.handleError(error, { 
           showToast: true,
           logToConsole: true,
           customMessage: 'Login failed. Please check your credentials and try again.'
         }))
       );
     }//end of postMethod

  /**
   *


  /**
   *
   * This function will call DELETE APIs.
   */
  deleteMethod(endpoint: any, apiConstant: any) {
    return this.httpService.delete<any>(endpoint + apiConstant).pipe(
      timeoutWithFallback(60000, 'Request timed out. Please try again.'),
      retryWithBackoff({ maxRetries: 2, baseDelay: 1000 }),
      catchError((error: HttpErrorResponse) => this.errorHandling.handleError(error, { 
        showToast: true,
        logToConsole: true 
      }))
    );
  }//end of deleteMethod


  deletepostMethod(endpoint: any, apiConstant: any, payload: any, headers: HttpHeaders, httpService?: any) {
    return this.httpService.delete<any>(endpoint + apiConstant,  { headers }).pipe(
      timeoutWithFallback(60000, 'Request timed out. Please try again.'),
      catchError((error: HttpErrorResponse) => this.errorHandling.handleError(error, { 
        showToast: true,
        logToConsole: true 
      }))
    );
  }//end of deletepostMethod



}//end of class